var utils = require('../../utils')

export default {
  name: 'message-send-officer',
  created () {
  },
  data () {
    return {
      messageOfficerContent: null,
      clicked: false
    }
  },
  computed: {
  },
  methods: {
    goTop: function () {
      this.$router.push({ path: '/'})
    },
    messageSent: function () {
      this.clicked = true
      var self = this
      var data = {
        'user_id': window.localStorage.getItem('user_id'),
        'shop_id': window.localStorage.getItem('shop_id'),
        'officer_content': self.messageOfficerContent,
        'base_url': process.env.ASOVI_URL
      }
      var callback = function() {
        self.$router.push({ path: '/message_sent_officer/'})
      }
      this.$store.dispatch('MESSAGE_SEND', {data: data, callback: callback})
    },
    notInput: function() {
      if (this.messageOfficerContent) {
        return false
      } else {
        return true
      }
    },
    rmEmoji: function(text) {
      this.messageOfficerContent = utils.removeEmoji(text)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/message-send-officer.js